
import axios from 'axios';
import { ENDPOINT } from '../ENDPOINT';

const BreakTypeService = {
  getAllBreaks: async () => {
    try {
      const response = await axios.get(ENDPOINT.breaktype);
      return response.data;
    } catch (error) {
      console.error("Error fetching break types:", error);
      throw error;
    }
  },

  createBreak: async (payload) => {
    try {
      const response = await axios.post(ENDPOINT.breaktype, payload);
      return response.data;
    } catch (error) {
      console.error("Error creating break type:", error);
      throw error;
    }
  },

  updateBreak: async (id, payload) => {
    try {
      const response = await axios.put(`${ENDPOINT.breaktype}/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating break type:", error);
      throw error;
    }
  },

  deleteBreak: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.breaktype}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting break type:", error);
      throw error;
    }
  },
};

export default BreakTypeService;
